<template>
  <transition name="fade">
    <div v-if="message" class="form-message" :class="type">
      <i :class="iconClass"></i>
      <span>{{ message }}</span>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'FormMessage',
  props: {
    message: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'success',
      validator: (value) => ['success', 'error'].includes(value)
    }
  },
  computed: {
    iconClass() {
      return this.type === 'success' 
        ? 'fas fa-check-circle' 
        : 'fas fa-exclamation-circle'
    }
  }
}
</script>

<style scoped>
.form-message {
  margin-top: 24px;
  padding: 16px 20px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 500;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.form-message.success {
  background: #d1fae5;
  color: #065f46;
  border: 1px solid #6ee7b7;
}

.form-message.error {
  background: #fee2e2;
  color: #991b1b;
  border: 1px solid #fca5a5;
}

.form-message i {
  font-size: 1.25rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>

